import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

const useGrossPricesAtom = atomWithStorage('builder-use-gross-prices', false);

export const useGrossPricesState = () => useAtom(useGrossPricesAtom);
